import React, { PropsWithChildren } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { theme } from '../theme/theme';
import { cssVariables } from '../theme/colors';

// Create a provider component that will wrap your app
export const MUIThemeContext: React.FC<PropsWithChildren> = ({ children }) => {
  // Inject CSS variables
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = cssVariables;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Provide the context value and MUI theme to the children components
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
